module.exports = __webpack_public_path__ + "img/up-btn.b75d0c47.svg";